import fetchAPI from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { parseError } from '../../utils/fetchErrorParser';
import { enqueueSnackbar } from './snackbar';
import store from '../store';
import * as ENVIRONMENT from '../../shared/config/config';
import { USER_TYPE } from '../../utils/constants';
import { VERSION } from '../../shared/config/version';

export const listUsers = () => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.USERS_LIST_LOADING,
  });

  const body = { collectionName: 'Users' };

  return fetchAPI
    .post('users/users', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }

      return result.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.USERS_LIST_SUCCESS,
        payload: {
          users: data.data,
          paginatedElements: data.data.length,
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.USERS_LIST_ERROR,
        payload: { ...error, message: errorMessage },
      });
    });
};

export const fetchCompanyUsers = (companyId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.COMPANIES_USERS_LIST_LOADING,
  });

  const body = { query: { companyId } };

  return fetchAPI
    .post('users/fetch/companyUsers', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }

      return result.json();
    })
    .then((data) => {
      const emailIds = data?.data?.map(item => item.emailAddress);
      dispatch({
        type: REDUX_ACTIONS.COMPANIES_USERS_LIST_SUCCESS,
        payload: emailIds
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.COMPANIES_USERS_LIST_ERROR,
        payload: { ...error, message: errorMessage },
      });
    });
};

export const listAlarmRecipientUsers = (body) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.ALARMS_RECIPIENTS_USERS_LIST_LOADING,
  });
  const query = { ...body };
  return fetchAPI
    .post('users/fetch/alarms', { query })
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.ALARMS_RECIPIENTS_USERS_LIST_SUCCESS,
        payload: {
          users: data.data,
          paginatedElements: data.data.length,
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.ALARMS_RECIPIENTS_USERS_LIST_ERROR,
        payload: { ...error, message: errorMessage },
      });
    });
};

export const addNewUsersRow = () => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.USERS_ADD_DISABLE,
    payload: true
  });
  const { users, currentUser } = store.getState();
  const newUsers = [...users.data];
  const nextId = newUsers.length - 1;

  function generateRandom() {
    const length = 24;
    const charset = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let retVal = '';
    for (let i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }

  const newRow = {
    firstName: '',
    emailAddress: '',
    phone: '',
    companyId: '',
    companyName: '',
    type: '',
    orders: [],
    quotes: [],
    userId: currentUser.userId,
    grid_id: nextId + 1,
    _id: generateRandom(),
    isNewRow: true,
    active: true,
    isDirty: true
  };
  newUsers.unshift(newRow);

  dispatch({
    type: REDUX_ACTIONS.USERS_LIST_SUCCESS,
    payload: {
      users: newUsers,
      paginatedElements: newUsers.length,
    },
  });
};

export const updateUserDetails = (body) => (dispatch) => {
  return fetchAPI
    .put('users', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch({
        type: REDUX_ACTIONS.USERS_ADD_DISABLE,
        payload: false
      });
      dispatch(listUsers());
      dispatch(
        enqueueSnackbar(
          'User Details Updated Successfully.',
          'success',
          new Date().getTime() + Math.random()
        )
      );
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
    });
};

export const addNewUser = (body) => (dispatch) => {
  return fetchAPI
    .post('users/user-create', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch({
        type: REDUX_ACTIONS.USERS_ADD_DISABLE,
        payload: false
      });
      dispatch(listUsers());
      dispatch(
        enqueueSnackbar(
          'User Added Successfully.',
          'success',
          new Date().getTime() + Math.random()
        )
      );
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
    });
};

export const postProofOfDelivery = (file, userId, order) => async (dispatch) => {
  const { _id } = order;
  dispatch({
    type: REDUX_ACTIONS.USERS_POD_UPLOAD_LOADING,
    payload: _id
  });
  const formData = new FormData();
  const { currentUser } = store.getState();
  const BASE_URL = ENVIRONMENT.API_URL;
  formData.append('file', file);
  const payload = {
    input: {
      orderNumber: order.orderNumber
    },
    user: {
      type: currentUser.type,
      companyId: currentUser.companyId,
      userId: currentUser.userId,
      version: VERSION
    },
  };
  formData.append('payload', JSON.stringify(payload));
  try {
    const response = await fetch(`${BASE_URL}orders/pod/upload`, {
      method: 'POST',
      body: formData,
      credentials: 'include',
    });

    if (!response.ok) {
      return Promise.reject(response);
    }
    dispatch({
      type: REDUX_ACTIONS.USERS_SET_POD,
      payload: { userId, orderId: _id, POD: true },
    });
    dispatch(
      enqueueSnackbar(
        'POD Uploaded Successfully',
        'success',
        new Date().getTime() + Math.random()
      )
    );
  } catch (error) {
    const errorMessage = await parseError(error);
    dispatch(
      enqueueSnackbar(
        errorMessage,
        'error',
        new Date().getTime() + Math.random()
      )
    );
  }
};

export const fetchUserOrders = (userId, vendorId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.USER_ORDERS_LIST_LOADING,
  });
  const body = {
    query: {
      userId,
      vendorId
    }
  };
  return fetchAPI
    .post('users/fetch/orders', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.USER_ORDERS_LIST_SUCCESS,
        payload: {
          data: data.data,
          paginatedElements: data.data.length,
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.USER_ORDERS_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};
export const fetchUserQuotes = (userId, vendorId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.USER_QUOTES_LIST_LOADING,
  });
  const body = {
    query: {
      userId,
      vendorId
    }
  };
  return fetchAPI
    .post('users/fetch/quotes', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.USER_QUOTES_LIST_SUCCESS,
        payload: {
          data: data.data,
          paginatedElements: data.data.length,
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.USER_QUOTES_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};

export const fetchSalesReps = (type) => (dispatch) => {
  const { currentUser } = store.getState();
  dispatch({
    type: REDUX_ACTIONS.SALES_REPS_LIST_LOADING,
  });

  const query = {
    companyId: type === USER_TYPE.CUSTOMER_USER ? currentUser?.companyId : undefined,
    userId: type === USER_TYPE.CUSTOMER_RIG ? currentUser?.userId : undefined,
  };

  const body = { query };

  return fetchAPI
    .post('marketplace/fetch/salesReps', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.SALES_REPS_LIST_SUCCESS,
        payload: {
          data: data?.data,
          paginatedElements: data?.data.length
        }
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.SALES_REPS_LIST_ERROR,
        payload: { ...error, message: errorMessage },
      });
    });
};

export const updateActiveUser = (payload) => (dispatch) => {
  const { active, _id } = payload;
  dispatch({
    type: REDUX_ACTIONS.USERS_LIST_LOADING,
  });
  const body = {
    query: {
      _id
    },
    input: {
      active
    }
  };
  return fetchAPI
    .put('users/status', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          active ? 'User Activated' : 'User Deactivated',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listUsers());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listUsers());
    });
};
